// extracted by mini-css-extract-plugin
module.exports = {"main":"PersBiz_main__3SbGe","containerHeader":"PersBiz_containerHeader__1ZwKu","content":"PersBiz_content__FD1N9"};